var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileFile01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#E8ECEF;}\n\t.st1{fill:#1A73E8;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,0.5h262c6.9,0,12.5,5.6,12.5,12.5v262c0,6.9-5.6,12.5-12.5,12.5H13c-6.9,0-12.5-5.6-12.5-12.5V13 C0.5,6.1,6.1,0.5,13,0.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.6,101c-4.9,0-8.8,3.9-8.8,8.8l0,70.4c0,4.9,3.9,8.8,8.8,8.8h52.9c4.9,0,8.8-3.9,8.8-8.8v-52.8L152.8,101 H117.6z M148.4,131.8v-24.2l24.2,24.2H148.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFile01);
export default __webpack_public_path__ + "static/media/file-file-01.e66b9849118593091bf5e218b94330e1.svg";
export { ForwardRef as ReactComponent };